import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { DashboardNotification } from "@fusion-advantage/formlib"
import { CloudToDeviceOfflineTableDashboardNotificationsBody } from "../redux/syncthunk/ZCloudToDevice"
import { bulkInsert } from "./bulkInsert"
import { sqlQuery, sqlRun } from "./ldb"
import { err, ok, Result } from "neverthrow"

export const selectAllDashboardNotifications = async (): Promise<Result<DashboardNotification[], FusionError>> => {
	let r = await sqlQuery<DashboardNotification>(`
		select Id, IsPersonal, Notification, EffectiveOn, ExpiresOn
			from dashboardNotification
	`)
	if(r.isErr()) {
		return err(serializeFusionError('selectAllDashboardNotifications', r.error))
	}
	return ok(r.value)
}

export const ldbDashboardNotificationBulkInsert = async (body: CloudToDeviceOfflineTableDashboardNotificationsBody): Promise<Result<void, FusionError>> => {
	let r = await sqlRun('delete from dashboardNotification')
	if(r.isErr()) {
		return err(serializeFusionError('ldbDashboardNotificationBulkInsert', r.error))
	}
	let params = []
	for (let m of body.DashboardNotifications) {
		params.push(null, m.IsPersonal, m.Notification, m.EffectiveOn, m.ExpiresOn)
	}
	r = await bulkInsert('dashboardNotification', params, 5)
	if(r.isErr()) {
		return err(serializeFusionError('ldbDashboardNotificationBulkInsert', r.error))
	}
	return ok()
}
